module.exports = __webpack_public_path__ + "img/74.b85b558f.jpg";